// extracted by mini-css-extract-plugin
export default {"wrapper":"Egj8C9SG","tabBar":"cAUUXHXg","sticky":"lkyoM8va","slideDown":"TGggt8_v","tab":"XKULBZz2","active":"JXYUOU47","policiesBar":"NwvVEvz7","content":"XWt8sL8U"};